import { useEffect, useState } from "react";
import { CiClock2 } from "react-icons/ci";
import { ButtonV2 } from "../../components/buttonv2";
import { orderIdentifier } from "../../helpers/orderIdentifier";

const formatOrderDate = (input, { utc = false } = {}) => {
  let date;

  if (input instanceof Date) {
    date = input;
  } else if (typeof input === "number") {
    date = new Date(input < 1e12 ? input * 1000 : input);
  } else if (typeof input === "string") {
    date = new Date(input);
  } else {
    return "";
  }

  if (Number.isNaN(date.getTime())) return "";

  const pad = (value) => String(value).padStart(2, "0");
  const hours = utc ? date.getUTCHours() : date.getHours();
  const minutes = utc ? date.getUTCMinutes() : date.getMinutes();
  const day = utc ? date.getUTCDate() : date.getDate();
  const month = utc ? date.getUTCMonth() + 1 : date.getMonth() + 1;

  return `${pad(hours)}:${pad(minutes)} - ${pad(day)}/${pad(month)}`;
};

const formatElapsedTime = (dateValue) => {
  const updatedAt = new Date(dateValue).getTime();
  if (!dateValue || Number.isNaN(updatedAt)) return "";

  const elapsedSeconds = Math.max(0, Math.floor((Date.now() - updatedAt) / 1000));
  const days = Math.floor(elapsedSeconds / 86400);
  const hours = Math.floor((elapsedSeconds % 86400) / 3600);
  const minutes = Math.floor((elapsedSeconds % 3600) / 60);
  const seconds = elapsedSeconds % 60;

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  parts.push(`${minutes}m`);
  parts.push(`${String(seconds).padStart(2, "0")}s`);

  return parts.join(" ");
};

export const Header = ({ orderData, handleAllStateOrderData }) => {
  const [elapsedTime, setElapsedTime] = useState(() => formatElapsedTime(orderData?.createdAt));

  useEffect(() => {
    const updateElapsedTime = () => setElapsedTime(formatElapsedTime(orderData?.createdAt));
    updateElapsedTime();

    const interval = setInterval(updateElapsedTime, 1000);
    return () => clearInterval(interval);
  }, [orderData?.updatedAt]);

  const orderFinished = Boolean(
    orderData?.products?.length &&
    orderData.products.length === orderData.products.filter((product) => product.status === "prepared").length,
  );

  const actionText =
    orderData?.status === "pending" ? "Iniciar todo" : orderData?.status === "inPreparation" ? "Terminar todo" : "Reiniciar todo";

  const handleOrderAction = () => {
    if (!orderData || orderFinished) return;

    const nextStatus =
      orderData.status === "pending" ? "inPreparation" : orderData.status === "inPreparation" ? "preparedProducts" : "pending";

    handleAllStateOrderData(nextStatus);
  };

  return (
    <div className="orderHeader">
      <div className="orderHeaderRow">
        <div className="orderHeaderTitle">
          <div>{orderIdentifier(orderData)}</div>
          <div className="orderHeaderRow">
            <div>
              <small>{formatOrderDate(orderData?.createdAt)}</small>
            </div>
            <div />
          </div>
        </div>

        <div className="orderHeader-handleState orderHeader-handleStateRaised">
          <>
            <div className="orderHeader-timer" style={{ padding: "10px 5px 0 0" }}>
              {elapsedTime && (
                <>
                  <CiClock2 /> {elapsedTime}
                </>
              )}
            </div>
            <div className="flex-end w-100">
              {!orderFinished ? (
                actionText === "Terminar todo" ? (
                  <div className="textStatepending">En proceso</div>
                ) : (
                  <ButtonV2 action={handleOrderAction} text={actionText} />
                )
              ) : (
                <ButtonV2 classname="orderActionConfirm" action={() => handleAllStateOrderData("prepared")} text="Confirmar" />
              )}
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export const BodyList = ({ ingredient, ingredientIndex, handleStateOrderData }) => {
  const actionText =
    ingredient.status === "prepared" ? "Volver a pendiente" : "Marcar preparado";

  return (
    <div className={`orderItem orderItemState-${ingredient.status}`} key={ingredientIndex}>
      <div className="orderItemHeader">
        <div className="orderItemQuantity">{ingredient.quantity || 0}</div>
        <div className="orderItemName">{ingredient.name}</div>
        <div className="orderItem-handleState">
          {ingredient.status === "pending" && <ButtonV2 action={() => handleStateOrderData(ingredient.orderProductId, "inPreparation")} text="Iniciar línea" />}
          <ButtonV2 action={() => handleStateOrderData(ingredient.orderProductId)} text={actionText} />
        </div>
      </div>
      <div className="orderItemExtra">
        {(ingredient?.itemIds || []).map((itemId, index) => {
          const item = ingredient.selectedItems?.find(selected => selected.itemId === itemId);
          return <div key={`${itemId}-${index}`}>{item?.name || "Extra no disponible"}</div>;
        })}
      </div>
      <div className="orderItemExtra">
        {ingredient?.variantId && (
          ingredient.selectedOptions?.some(option => option.name)
            ? ingredient.selectedOptions.filter(option => option.name).map(option => option.name).join(" · ")
            : "Combinación no disponible"
        )}
      </div>
      {ingredient?.note && (
        <div className="orderItemNotes">
          *<em>{ingredient?.note}</em>*
        </div>
      )}
    </div>
  );
};
